module.exports = __webpack_public_path__ + "img/banner-bottom.b7cee6a0.jpg";